import { XauditModel } from "src/app/models/xaudit.model";
import { CfgNoteToFrontAutoFillDetailOperatories } from "./cfg-note-to-front-auto-fill-detail-operatories.model";

export class NotesToFrontAutoFillDetail extends XauditModel {
    AutoFillDetailID: string;
    AutoFillID: string;
    AutoFillOrder: number;
    Name: string;
    enumNextApptID: string;
    enumNextApptLengthID: string;
    enumNextApptWhenID: string;
	cfgNoteToFrontAutoFillDetailOperatories: CfgNoteToFrontAutoFillDetailOperatories[];
}
